import { createPiecesJointes, updatePiecesJointes } from '@/api/pieceJointes/index';

export async function insertPieceJointe(piecesJointes, elementId, pjType) {
  if (!elementId || elementId === undefined) {
    throw new Error('No Id');
  }
  const formdata = new FormData();
  let data;
  if (piecesJointes && piecesJointes.length) {
    let i = 0;
    // eslint-disable-next-line
    for (const pj of piecesJointes) {
      if (pj.file) {
        formdata.append(`attachments${i}`, pj.file);
        const compressed = new File([pj.compressedFile], pj.file.name);
        formdata.append(`attachments${i}_min`, compressed);
        i += 1;
      }
    }
    data = piecesJointes.map(pj => ({
      size: pj.size,
      description: pj.description,
      typeId: pj.typeId,
      nom: pj.name || pj.nom,
      placeType: pj.placeType,
    }));
  }
  if (piecesJointes && piecesJointes.length) {
    formdata.append('data', JSON.stringify({ elementId, type: pjType, piecesJointes: data }));
    await createPiecesJointes(formdata);
  }
}

export async function updatePieceJointe(piecesJointes, elementId, pjType) {
  if (!elementId || elementId === undefined) {
    throw new Error('No Id');
  }
  const formdata = new FormData();
  let i = 0;
  // eslint-disable-next-line
  for (const pj of piecesJointes) {
    if (pj.file) {
      formdata.append(`attachments${i}`, pj.file);
      const compressed = new File([pj.compressedFile], pj.file.name);
      formdata.append(`attachments${i}_min`, compressed);
      i += 1;
    }
  }
  const data = piecesJointes.filter(pj => pj).map(pj => ({
    id: pj.id,
    size: pj.size,
    description: pj.description,
    typeId: pj.typeId,
    nom: pj.name || pj.nom,
    chemin: pj.chemin,
    thumb: pj.thumb,
    placeType: pj.placeType,
    conserveAnciennePj: pj.conserveAnciennePj,
  }));
  formdata.append('data', JSON.stringify({ elementId, type: pjType, piecesJointes: data }));
  const response = await updatePiecesJointes(formdata);
  return response.data.result;
}
